// Share the instance module in the next-shared layer
import { actionAsyncStorageInstance } from './action-async-storage-instance' with {
    'turbopack-transition': 'next-shared'
};
export { actionAsyncStorageInstance as actionAsyncStorage };

//# sourceMappingURL=action-async-storage.external.js.map